import React from 'react';
import { SearchMetaWrapper } from '@jetshop/ui/Search/SearchPage/SearchMeta';
import { PageOf } from '@jetshop/ui/Search/SearchPage/PageOf';
import t from '@jetshop/intl';
import styled from 'react-emotion';

const Matches = styled('div')`
  color: #999999;
  span {
    text-transform: uppercase;
    color: #141414;
    padding-right: 0.5rem;
  }
`;

const SearchMeta = ({ total, page, pages }) => (
  <SearchMetaWrapper>
    <Matches>
      <span>{t('Product Matches')}:</span>
      {t('{total, plural, =1 {# item} other {# items}}', {
        total
      })}
    </Matches>
  </SearchMetaWrapper>
);

export default SearchMeta;
